// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  touch-action: none;
}

.drag-handle {
  cursor: all-scroll !important;
}

.drag-handle:active {
  cursor: all-scroll !important;
}

.icon-delete:hover {
  color: rgb(211, 0, 0);
  transform: scale(1.2);
  transition: 0.3s ease-in-out;
  cursor: pointer;
}

.icon-delete {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ManageModules/ModuleItem.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".card {\n  touch-action: none;\n}\n\n.drag-handle {\n  cursor: all-scroll !important;\n}\n\n.drag-handle:active {\n  cursor: all-scroll !important;\n}\n\n.icon-delete:hover {\n  color: rgb(211, 0, 0);\n  transform: scale(1.2);\n  transition: 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.icon-delete {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
